var map = {
	"./api-developement.png": "./src/img/services/api-developement.png",
	"./digital-campaigns-project-managemement.png": "./src/img/services/digital-campaigns-project-managemement.png",
	"./digital-consultancy.png": "./src/img/services/digital-consultancy.png",
	"./email-marketing-services.png": "./src/img/services/email-marketing-services.png",
	"./fulfillment-of-social-relationship-management.png": "./src/img/services/fulfillment-of-social-relationship-management.png",
	"./services.jpg": "./src/img/services/services.jpg",
	"./social-media-apps-and-mobile-apps-production.png": "./src/img/services/social-media-apps-and-mobile-apps-production.png",
	"./social-media-management.png": "./src/img/services/social-media-management.png",
	"./web-systems-developement.png": "./src/img/services/web-systems-developement.png",
	"./website-build-and-management.png": "./src/img/services/website-build-and-management.png",
	"./whole-range-of-digital-backend-production.png": "./src/img/services/whole-range-of-digital-backend-production.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/services sync \\.(png%7Cjpe?g%7Csvg)$";